import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { HeartPulse, Loader2 } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function CsLeadCard() {
  const [lead, setLead] = useState(null);
  const [pick, setPick] = useState("");
  const [agents, setAgents] = useState([]);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    axios.get(`${API}/customer-success/cs-lead`)
      .then((r) => { setLead(r.data); setPick(r.data.cs_lead_id || ""); })
      .catch(() => toast.error("Failed to load the CS lead"));
    axios.get(`${API}/agents/mapping`)
      .then((r) => setAgents((r.data.agents || []).filter((a) => a.id !== "emergency")))
      .catch(() => {});
  }, []);

  const dirty = lead && pick !== (lead.cs_lead_id || "");

  const save = async () => {
    setBusy(true);
    try {
      const r = await axios.put(`${API}/customer-success/cs-lead`, { cs_lead_id: pick });
      setLead(r.data); setPick(r.data.cs_lead_id || "");
      toast.success(`Health checks now fall back to ${r.data.cs_lead_name}`);
    } catch (e) { toast.error(e?.response?.data?.detail || "Failed to save"); }
    finally { setBusy(false); }
  };

  return (
    <Card className="border-[#DAD5CA] shadow-none" data-testid="admin-cs-lead">
      <CardContent className="p-5">
        <div className="flex items-center gap-2">
          <HeartPulse className="w-4 h-4 text-[#8A857A]" />
          <span className="text-[14px] font-bold text-[#1A1A1A]" style={{ fontFamily: "Manrope, sans-serif" }}>Customer Success — health check owner</span>
        </div>
        <p className="mt-1 text-[13px] text-[#59554D]">
          Every client with a next-check date raises a Health check to-do. It goes to the client's CSM;
          when a client has no CSM on their journey it falls back to this person.
        </p>
        {!lead ? (
          <div className="mt-4 h-[56px] bg-[#F6F4EF] rounded animate-pulse" />
        ) : (
          <div className="mt-4 flex items-end gap-3 flex-wrap">
            <div className="min-w-0">
              <label className="text-[11.5px] font-semibold text-[#59554D]">CS lead</label>
              <Select value={pick} onValueChange={setPick}>
                <SelectTrigger className="mt-1 h-9 w-[240px] border-[#DAD5CA]" data-testid="cs-lead-select">
                  <SelectValue placeholder="Choose a person" />
                </SelectTrigger>
                <SelectContent className="bg-white border-[#DAD5CA]">
                  {agents.map((a) => <SelectItem key={a.id} value={a.id}>{a.name}</SelectItem>)}
                </SelectContent>
              </Select>
            </div>
            <Button onClick={save} disabled={!dirty || busy} data-testid="cs-lead-save"
                    className="h-9 bg-[#FFD108] hover:bg-[#E0B800] text-[#121212] font-semibold disabled:bg-[#E6E2D9] disabled:text-[#B5AFA3]">
              {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : "Save CS lead"}
            </Button>
            {!dirty && <span className="text-[12px] text-[#8A857A] pb-2">Currently {lead.cs_lead_name}.</span>}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
